import { render } from "./CategoryFeature.vue?vue&type=template&id=7e66d21c&scoped=true"
import script from "./CategoryFeature.vue?vue&type=script&lang=js"
export * from "./CategoryFeature.vue?vue&type=script&lang=js"

import "./CategoryFeature.vue?vue&type=style&index=0&id=7e66d21c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e66d21c"]])

export default __exports__